import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'esa-ui-library';
import { Form, passFairValidator, passStrongValidator, PasswordIndicator } from '../../../..';
import { REPEAT_INVALID_MESSAGE } from '../../../..';
import { getUrlParam, useStore, useValidator } from '../../../../../common';

interface ResetFormProps {
	onSubmit: () => void;
	hasTwoStep?: boolean;
}

const ResetForm: FC<ResetFormProps> = ({
	onSubmit,
	hasTwoStep = getUrlParam('has_two_step') === 'true',
}): JSX.Element => {
	const [state, dispatch] = useStore(true);
	const {
		password: initialPassword,
		passwordFair,
		passwordStrong,
		repeatPassword: initialRepeatPassword,
		repeatInvalid,
		two_step_code: initialTwoStepCode,
		errors,
		success,
	} = state;

	const [password, setPassword] = React.useState(initialPassword);
	const [repeatPassword, setRepeatPassword] = React.useState(initialRepeatPassword);
	const [twoStepCode, setTwoStepCode] = React.useState(initialTwoStepCode || '');

	useValidator(repeatPassword, () => repeatPassword === password, 'REPEAT_INVALID');
	useValidator(password, passFairValidator, 'PASS_FAIR');
	useValidator(password, passStrongValidator, 'PASS_STRONG');

	const onPasswordChange = (val: string) => {
		setPassword(val);
		dispatch('PASS', val);
	};

	const onRepeatChange = (val: string) => {
		setRepeatPassword(val);
		dispatch('REPEAT_PASS', val);
	};

	const onTwoStepCodeChange = (val: string) => {
		setTwoStepCode(val);
		dispatch('TWO_STEP_CODE', val);
	};

	const isSubmitDisabled = !repeatPassword || repeatInvalid || (hasTwoStep && !twoStepCode) || !passwordStrong;

	return (
		<Form errors={errors} success={success}>
			<Input
				type='password'
				label='New Password'
				value={password}
				placeholder='Enter your password here'
				dataId='password-field'
				onChange={onPasswordChange}
			/>
			<Input
				type='password'
				label='Repeat Password'
				value={repeatPassword}
				placeholder='Enter your password here'
				dataId='repeat-pass-field'
				disabled={!password}
				onChange={onRepeatChange}
				error={repeatInvalid}
				errorMessage={REPEAT_INVALID_MESSAGE}
			/>
			{hasTwoStep && (
				<Input
					type='number'
					label='Two step code'
					value={twoStepCode}
					placeholder='Enter your two step code here'
					dataId='two-step-code-field'
					onChange={onTwoStepCodeChange}
					name='two_step_code'
				/>
			)}
			{password && <PasswordIndicator fair={passwordFair} strong={passwordStrong} />}
			<Button title='Continue' fluid primary disabled={isSubmitDisabled} dataId='reset-button' onClick={onSubmit} />
		</Form>
	);
};

ResetForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	hasTwoStep: PropTypes.bool,
};

export { ResetForm };
